import StudentJourneyTreeView from '@/components/showcase-modules/student-journey-tree-view/student-journey-tree-view';
import { Vue, Component } from 'vue-property-decorator';
import { markersAPI } from '@/providers/apis/markers/markers';
import { sessionService } from '@/providers/services/auth/session';
import { appConfigService } from '@/providers/services/app/app-config';
import LearningIdentityChartLine from '@/components/charts/learner-identity-chart-line/learner-identity-chart-line';

@Component({
    name: 'facet-detail-view',
    components: {
        'student-journey-view': StudentJourneyTreeView,
        'learner-identity-line': LearningIdentityChartLine,
    },
})
export default class FacetDetailView extends Vue {

    // ----------------------------------------------------------
    // Properties

    public activeMarker: any = null;

    public isLoading: boolean = false;

    public strongLearner: any = null;

    public weakLearner: any = null;

    public get session() {
        return sessionService.getSession();
    }


    // ----------------------------------------------------------
    // Hooks

    public created() {
        const markerId = this.$route.query.markerId;
        this.isLoading = true;
        this.loadConfigData();
        this.searchMarkers(markerId);
    }

    // ----------------------------------------------------------
    // Actions

    public onGoBack() {
        this.$router.push('/showcase-revamp?isPlayground=true');
    }

    // ----------------------------------------------------------
    // Methods

    private searchMarkers(markerId: any) {
        const params: any = {
          filters: {
           'txFramework.fwCode': 'TMA',
            'txSubject.txSubjectCode': 'K12.MA',
          },
          limit: 10,
          offset: 0,
        };
        markersAPI.searchMarkers(params).then((markerList) => {
            this.activeMarker = markerList.find((item) => item.id === markerId);
            this.isLoading = false;
        });
    }

    private loadConfigData() {
        const session = this.session;
        const learnersList =  appConfigService.showcaseLearners();
        const strongLearner = learnersList.strongLearner;
        const weakLearner = learnersList.weakLearner;
        this.strongLearner = strongLearner[session!.user_id] || strongLearner.default;
        this.weakLearner = weakLearner[session!.user_id] || weakLearner.default;
    }
}
